import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";

export class Communication extends Component {

    render() {
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'communication'}
            title={'PROCEDURE P7.0 COMMUNICATION'}
            exportTitle={'<h2>Procedure P7.0 Communication</h2>'}
            exportFileName={'communication.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (Communication);